import { useMemo } from 'react';
import { PrinterIcon } from '@heroicons/react/24/outline';
import { t } from '../i18n'
import { billHtml, printBill } from '../utils/bill'

// Bill preview for an order: the same receipt that goes to the printer.
const InvoiceRenderer = ({ order, onClose, businessInfo }) => {
  const business = useMemo(() => ({ ...businessInfo, footer: businessInfo?.footer || businessInfo?.welcomeMessage }), [businessInfo])
  const html = useMemo(() => (order ? billHtml(order, business) : ''), [order, business])

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" role="dialog" aria-modal="true">
      <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <div>
            <h2 className="text-lg font-bold">{t("Print Bill")}</h2>
            <p className="text-gray-600 text-sm">{t("Order #")}{order?.order_code}</p>
          </div>
          <div className="flex gap-2">
            <button type="button" onClick={() => printBill(order, business)}
              className="bg-blue-600 text-white flex items-center gap-2 rounded-lg px-3 py-2 hover:bg-blue-700 transition-colors text-sm">
              <PrinterIcon className="h-4 w-4" />
              {t("Print Bill")}
            </button>
            <button type="button" onClick={onClose}
              className="border border-gray-300 text-gray-700 rounded-lg px-3 py-2 hover:bg-gray-50 transition-colors text-sm">
              {t("Close")}
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-auto p-4 bg-gray-100 flex justify-center">
          <iframe title={t("Bill preview")} srcDoc={html} className="bg-white shadow-lg w-[80mm] min-h-[60vh] border-0" />
        </div>
      </div>
    </div>
  );
};

export default InvoiceRenderer;
